import React from 'react';

function formatJobType(job) {
  try {
    const kinds = Array.isArray(job?.itemKinds)
      ? job.itemKinds
          .map((kind) => (kind == null ? '' : String(kind).trim()))
          .filter(Boolean)
          .join('_')
      : '';
    const jobType =
      job?.jobType == null ? '' : String(job.jobType).trim();
    const raw =
      jobType ||
      (job?.source === 'mixed_order_print_queue' ? 'mixed_order_print_queue' : '') ||
      kinds ||
      'print_job';
    return String(raw || 'print_job').replace(/_/g, ' ').toUpperCase();
  } catch {
    return 'PRINT JOB';
  }
}

function formatCreatedAt(value) {
  if (!value) return 'Unknown time';
  if (typeof value?.toDate === 'function') {
    try {
      return value.toDate().toLocaleString();
    } catch {
      return 'Unknown time';
    }
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? 'Unknown time' : date.toLocaleString();
}

export default function PrintHistoryModal({ history, onClose }) {
  const rows = Array.isArray(history) ? history.filter(Boolean) : [];

  return (
    <div className="modal-overlay">
      <div className="modal-content large">
        <div className="modal-header">
          <h2>Print History</h2>
          <button type="button" className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          {rows.length === 0 ? (
            <p>No print history available.</p>
          ) : (
            <div className="history-list">
              {rows.map((job, index) => (
                <div
                  key={job.id || `print-history-${index}`}
                  className="history-item"
                >
                  <div className="history-info">
                    <h4>{formatJobType(job)}</h4>
                    <p>{Number(job.orderCount) || 0} orders printed</p>
                    <small>{formatCreatedAt(job.createdAt)}</small>
                  </div>
                  <div className="history-status">
                    <span
                      className={`status-badge ${String(job.status || 'completed')}`}
                    >
                      {String(job.status || 'completed')}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="toolkit-btn toolkit-btn--primary"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
